import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { User } from '../models/User';

export class UserMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): User {
    return new User(this.gqlIdEncoder.decode(data.id), data.name, data.preferredName);
  }
}
